module.exports = __webpack_public_path__ + "img/2d750b7.jpg";